let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gk64V")).then(() => parcelRequire('5IIdf'));